import { apiGet, apiPost } from "@/lib/http/client";
import { withBillingReturnOrigin } from "@/features/billing/billingReturnOrigin";
import type {
  BillingCheckoutSessionRequest,
  BillingCheckoutSessionResponse,
  BillingPortalSessionRequest,
  BillingPortalSessionResponse,
  BillingStatus,
} from "@/types/api";

export async function fetchBillingStatus() {
  return apiGet<BillingStatus>("/billing/status");
}

export async function createBillingCheckoutSession(
  body: BillingCheckoutSessionRequest,
) {
  return apiPost<BillingCheckoutSessionResponse>(
    "/billing/checkout-session",
    withBillingReturnOrigin(body),
  );
}

export async function createBillingPortalSession(
  body: BillingPortalSessionRequest = {},
) {
  return apiPost<BillingPortalSessionResponse>(
    "/billing/portal-session",
    withBillingReturnOrigin(body),
  );
}
